import { Component } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { MaincontainerComponent } from '../maincontainer/maincontainer.component';
import { Base } from '../common/base';
import dataDocuments from '../../../assets/data/documentsPoblacion.json';
import { DialogPoblacionDetalleComponent } from '../common/dialogs/dialog-poblacion-detalle/dialog-poblacion-detalle.component';
import { DialogCarnetSendComponent } from '../common/dialogs/dialog-carnet-send/dialog-carnet-send.component';
import { CarnetImgModel, CarnetRespondeModel } from '../../models/carnet';
import { CarnetService } from '../../services/carnet/carnet.service';
import { DialogGenericFrame } from '../common/dialogs/dialog-generic-frame/dialog-generic-frame.component';
import { environment as ENV } from '../../../environments/environment';
import { PoblacionService } from '../../services/poblacion/poblacion.service';
import { UserLoggedResponse, UserRolResponde } from '../../models/user';
import { StorageService } from '../../utils/util.storage.service';
import {
  Beneficiario,
  Contrato,
  ContratoWs,
} from '../../models/poblacion/mi-poblacion';
import { DialogRadicarSolicitudComponent } from '../../dialog-radicar-solicitud/dialog-radicar-solicitud.component';
import { FormularioSolicitudComponent } from '../formulario-solicitud/formulario-solicitud.component';
import { ServiceGetAfiliado } from '../../services/ciudad-select/servicioGetAfiliado.service';
import { GenericService } from '../../services/ciudad-select/genericService.service';
import { GeneralResponse } from '../../models/ciudad/generic-response';
import { error, log } from 'console';
import { AuthService } from '../../services/security/auth.service';
import { promise } from 'protractor';
import { URL_MAP } from '../../shared/urlMap';
import { ModalCertificadosComponent } from '../modal-certificados-poblacion/modal-certificados.component';
import { AutorizacionesService } from '../../services/mis-autorizaciones/misautorizaciones.service';
import { EMPTY, map, switchMap } from 'rxjs';
import { filter } from 'rxjs';
import { UTIL_BUSINESS_LINE } from '../../utils/utilconstant';

@Component({
  selector: 'app-poblacion',
  templateUrl: './poblacion.component.html',
  styleUrls: ['./poblacion.component.css'],
})
export class PoblacionComponent extends Base {
  public frmPoblacion: FormGroup = new FormGroup({});
  documentTypeData: any[] = dataDocuments as Array<any>;
  haveDate: boolean = false;
  haveResponde: boolean = false;
  generalMessage: string = '';
  identificationAgent: string = '';
  dsPoblacion: any[] = [];
  userImgData: CarnetImgModel = new CarnetImgModel();
  jsonRespuesta!: any;
  usuariosMiPoblacion: any[] = [];
  correo: string = '';
  logInfo: any;

  constructor(
    private _formBuilder: FormBuilder,
    private matDialog: MatDialog,
    private spinner: NgxSpinnerService,
    private mainCmp: MaincontainerComponent,
    private carnetService: CarnetService,
    private poblacionService: PoblacionService,
    private storageService: StorageService,
    private serviceGetAfiliado: ServiceGetAfiliado,
    private genericService: GenericService,
    private authService: AuthService,
    private autorizacionService: AutorizacionesService,
  ) {
    super();
    this.buildForm();
    this.getLogInfo();
  }

  getLogInfo() {
    return new Promise((resolve, reject) => {
      this.authService
        .getAuthInfo()
        .then((info) => {
          this.logInfo = info;
          resolve(info);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.mainCmp.setTitle('MI POBLACIÓN');
    });
  }

  private buildForm(): void {
    this.frmPoblacion = this._formBuilder.group({
      documentType: [null],
      documentNumber: [null, [Validators.maxLength(30), noSpacesValidator]],
      contractNumber: [
        null,
        [Validators.pattern('^[0-9]*$'), Validators.maxLength(8)],
      ],
    });
  }

  consultar() {
    this.frmPoblacion.value.documentNumber == ''
      ? (this.frmPoblacion.value.documentNumber = null)
      : null;
    this.frmPoblacion.value.contractNumber == ''
      ? (this.frmPoblacion.value.contractNumber = null)
      : null;
    this.spinner.show();
    if (this.frmPoblacion.valid) {
      if (
        (this.frmPoblacion.value.documentType !== null &&
          this.frmPoblacion.value.documentNumber !== null &&
          this.frmPoblacion.value.contractNumber === null) || // Solo los dos primeros diferentes de null
        (this.frmPoblacion.value.contractNumber !== null &&
          this.frmPoblacion.value.documentType === null &&
          this.frmPoblacion.value.documentNumber === null) || // Solo el tercero diferente de null
        (this.frmPoblacion.value.documentType !== null &&
          this.frmPoblacion.value.documentNumber !== null &&
          this.frmPoblacion.value.contractNumber !== null)
      ) {
        //los tres diferentes y valido

        const userCC: UserLoggedResponse =
          this.storageService.getItem('user') ?? 'Document no esta llegando';
        const role: UserRolResponde[] = userCC.roles;

        let userData = {
          typeDocument:
            this.frmPoblacion.value.documentType != null
              ? this.frmPoblacion.value.documentType
              : '',
          identification:
            this.frmPoblacion.value.documentNumber != null
              ? this.frmPoblacion.value.documentNumber
              : '',
          contrato:
            this.frmPoblacion.value.contractNumber != null
              ? this.frmPoblacion.value.contractNumber
              : '',
          identificationAsesor: this.deleteSpaceAsesor(userCC.document),
          typeAsesor: role[0].claveRol,
        };
        console.log('getMisUsuariosMiPoblacion');

        this.poblacionService
          .getMisUsuariosMiPoblacion(userData)
          .pipe(
            switchMap((response) => {
              console.log('Estos son los usuarios: ', response.data);
              this.usuariosMiPoblacion = response.data;
              //this.spinner.hide();
              this.jsonRespuesta = response;
              var respuesta = response.data.map((item: any) => {
                const { 'Linea de Negocio': _, ...rest } = item;
                return {
                  ...rest,
                  lineaDeNegocio: item['Linea de Negocio']?.replace(/\s+/g, ''),
                };
              });
              if (this.jsonRespuesta.data.length == 0) {
                this.haveDate = false;
                this.haveResponde = true;
                this.generalMessage =
                  'No se encontró información con los datos ingresados.';
                this.spinner.hide();
                return EMPTY;
              } else {
                this.identificationAgent = respuesta[0].Contratante;
                const reqAsesor = {
                  prm_docu_tipo:
                    userData.typeDocument == ''
                      ? this.identificationAgent.split('-')[0].trim()
                      : userData.typeDocument,
                  prm_docu_nro:
                    userData.identification == ''
                      ? this.identificationAgent
                          .split('-')[1]
                          .trim()
                          .split(' ')[0]
                      : userData.identification,
                };
                console.log(reqAsesor);
                return this.autorizacionService
                  .getAsesorPoblacion(reqAsesor)
                  .pipe(map((resp) => ({ respuesta, resp })));
              }
            }),
          )
          .subscribe({
            next: ({ respuesta, resp }) => {
              console.log(resp);
              console.log(respuesta);
              if (resp != null) {
                const isExterno = userCC.roles[0].claveRol == 'Ova_AseExter';
                // console.log(isExterno);
                // console.log((isExterno && resp.idAsesorPoblacion != '20') || (!isExterno && resp.idAsesorPoblacion == '20'));
                if (
                  (isExterno && resp.idAsesorPoblacion != '20') ||
                  (!isExterno && resp.idAsesorPoblacion == '20')
                ) {
                  // console.log('Entra al if');
                  this.haveDate = true;
                  this.haveResponde = true;
                  this.dsPoblacion = this.agruparPorContrato(respuesta);
                  this.spinner.hide();
                } else {
                  if (!isExterno && resp.idAsesorPoblacion != '20') {
                    this.generalMessage =
                      'Este usuario pertenece a la población del canal externo.';
                    this.haveDate = false;
                    this.haveResponde = false;
                    this.dsPoblacion = [];
                    this.spinner.hide();
                  } else if (isExterno && resp.idAsesorPoblacion == '20') {
                    this.haveDate = false;
                    this.haveResponde = true;
                    this.generalMessage =
                      'No se encontró información con los datos ingresados.';
                    this.dsPoblacion = [];
                    this.spinner.hide();
                  }
                  // console.log('Entra al else');
                }
              } else {
                this.haveDate = true;
                this.haveResponde = true;
                this.dsPoblacion = this.agruparPorContrato(respuesta);
                this.spinner.hide();
              }
            },
            error: (e) => {
              this.spinner.hide();
              this.haveResponde = false;
              this.haveDate = false;
              console.error('Error en la petición =>', e.error.errorMessage);
              this.generalMessage = 'Ocurrió un error al consultar.';
            },
          });
      } else {
        this.spinner.hide();
        this.haveResponde = false;
        this.haveDate = false;
        this.generalMessage = 'Faltan campos por diligenciar.';
      }
    } else {
      this.spinner.hide();
      this.haveResponde = false;
      this.haveDate = false;
      this.generalMessage =
        'Tienes errores en el diligenciamiento del formulario.';
    }
  }

  agruparPorContrato = (lista: ContratoWs[]): Contrato[] => {
    return lista.reduce((acc: Contrato[], item: ContratoWs) => {
      let grupo = acc.find((g) => g.contrato === item.Contrato);
      let beneficiario: Beneficiario = {
        nombre: item.nombre,
        identificacion: item.identificacion,
        parentesco: item.ParentescoReal,
        celular: item.Telefono,
        codiprograma: item.codiprograma,
        programa: item.Programa,
        estado: item.UsuarioConServicio,
      };
      if (grupo) {
        // Si existe, añadimos el item al grupo
        grupo.beneficiarios.push(beneficiario);
      } else {
        // Si no existe, creamos un nuevo grupo
        acc.push({
          contrato: item.Contrato,
          programa: item.Programa,
          nombre: item.Contratante,
          cuenta: item.Cuenta,
          beneficiarios: [beneficiario],
          lineaDeNegocio: item.lineaDeNegocio,
          showButtons:
            item.estado_cuenta == 'S' && item.estado_descripcion == 'S'
              ? true
              : false,
        });
      }

      return acc;
    }, []);
  };

  clear() {
    this.frmPoblacion.reset();
    this.haveDate = false;
    this.haveResponde = false;
    this.generalMessage = '';
  }

  seeDetails(dataBeneficiaro: Beneficiario, contrato: string) {
    this.spinner.show();
    console.log('data del beneficiario:', dataBeneficiaro);
    const [acronym, document] = dataBeneficiaro.identificacion.split(' - ');
    let data = {
      typeDocument: acronym,
      identification: document,
      contrato: contrato,
    };
    this.poblacionService.getDetalleUsuarioMiPoblacion(data).subscribe({
      next: (response) => {
        this.spinner.hide();
        if (response.data.length != 0) {
          const dialogRef = this.matDialog.open(
            DialogPoblacionDetalleComponent,
            {
              disableClose: true,
              data: response.data[0],
            },
          );
        } else {
          this.showMessageDialog(
            'Error',
            'No se pudo obtener la información del beneficiario.',
            'Aceptar',
            '',
            true,
            3,
            this.matDialog,
            (_: any) => {},
          );
        }
      },
      error: (error) => {
        this.spinner.hide();
        this.showMessageDialog(
          'Error',
          'No se pudo obtener la información del beneficiario.',
          'Aceptar',
          '',
          true,
          3,
          this.matDialog,
          (_: any) => {},
        );
      },
    });
  }

  async generateCarnet(data: Beneficiario, contrato: string) {
    this.spinner.show();
    const userCC: UserLoggedResponse =
      this.storageService.getItem('user') ?? 'Document no esta llegando';
    const role: UserRolResponde[] = userCC.roles;
    const [acronym, document] = data.identificacion.split(' - ');
    let userCarnetData = {
      typeDocument: acronym,
      identification: document,
      identificationAsesor: this.deleteSpaceAsesor(userCC.document),
      typeAsesor: role[0].claveRol,
    };

    let dataCarnet = await this.poblacionService.getCarnetData(userCarnetData);
    let imgCarnet = await this.poblacionService.getCarnetImagen(
      data.codiprograma,
    );

    var ownerData = { email: 'correo@prueba.com', cellphone: data.celular };

    const resultado: CarnetRespondeModel = dataCarnet.data.find(
      (persona: { identificacion: string; ContratoAfiliado: string }) =>
        persona.identificacion == data.identificacion &&
        persona.ContratoAfiliado === contrato,
    );
    resultado.imagen = imgCarnet.data[0].Carnet;
    var dataArray = [];
    dataArray.push(resultado);
    this.matDialog.open(DialogCarnetSendComponent, {
      disableClose: true,
      data: {
        option: 2,
        ownerData: ownerData,
        dataBeneficiaries: dataArray,
        showPreview: true,
      },
    });
    this.spinner.hide();
  }
  /*
    Se modifica getAfiliadoCore. Se agrega el parametro de programa padre
  */
  consultDirectory(data: Beneficiario) {
    console.log(data);
    const [acronym, document] = data.identificacion.split(' - ');
    this.serviceGetAfiliado
      .getAfiliadoCore('buscar', acronym, document)
      .subscribe({
        next: (resp) => {
          let users = resp.data;
          let conta = 0;
          let estado = false;
          let user = null;
          let business_line = null;
          if (users.length == 1) {
            user = users[0];
          } else if (users.length > 1) {
            while (conta < users.length && !estado) {
              // console.log(users[conta]);
              if (
                users[conta].numIdentificacion == document &&
                users[conta].programa == data.codiprograma
              ) {
                user = users[conta];
                estado = true;
              } else {
                conta += 1;
              }
            }
          }
          // console.log(user.lineaNegocio);
          business_line = UTIL_BUSINESS_LINE[user.lineaNegocio];
          const url = `${ENV.HOST_VISOR}${
            URL_MAP.EXTERNAL.VISOR_MEDICO
          }?&codeBook=${user.numCartilla}&businessLine=${business_line}&programCode=${user.planGrupo}`;
          // const url = `http://localhost/link-de-pagos-coomeva/cuotamensual/obtener-datos?strNumeroDocumento=${docNumber}&strTipoDocumento=${docType}&strUsuario=${btoa(
          //   ENV.EXTERNAL.autologinUserLinkPago
          // )}&strContrasenia=${btoa(ENV.EXTERNAL.autologinPassLinkPago)}&strRol=${tipoRol}&desdeModal=true`;
          // console.log('Debug => Trying to open => ', url);
          this.matDialog.open(DialogGenericFrame, {
            width: '90%',
            data: { url: url },
          });
        },
        error: (e) => {
          console.log(e);
        },
      });
    /*navigator.geolocation.getCurrentPosition(
      (position) => {
        const dataUser = data.identificacion.split('-');
        const tipeDocumentSearch = dataUser[0].trim();
        const documentSearch = dataUser[1].trim();
        const nameProgram = data.programa;
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;
        const url = `${ENV.HOST}${URL_MAP.EXTERNAL.DIRECTORIO}?&latitude=${latitude}&longitude=${longitude}&tipeDocumentSearch=${tipeDocumentSearch}&documentSearch=${documentSearch}&nameProgram=${nameProgram}`;
        this.matDialog.open(DialogGenericFrame, {
          width: '90%',
          data: {
            url: url,
            position: position,
          },
        });
      },
      (error) => {
        console.error('Error getting location', error);
      }
    );*/
  }

  radicar_solicitud(
    dataBeneficiario: any,
    contrato: string,
    lineaDeNegocio: any,
  ) {
    if (String(lineaDeNegocio) !== '1') {
      this.matDialog.open(DialogRadicarSolicitudComponent);
      return;
    }

    this.spinner.show();

    const [acronym, document] = dataBeneficiario.identificacion.split(' - ');
    const [apellido1, apellido2, ...nombresArray] =
      dataBeneficiario.nombre.split(' ');
    const nombres = nombresArray.join(' ');

    const datosConsulta = {
      typeDocument: acronym,
      identification: document,
      contrato: contrato,
    };

    let mappedData = {
      ...dataBeneficiario,
      tipoIdentificacion: acronym.trim(),
      identificacion: document.trim(),
      nombres: nombres,
      apellidos: `${apellido1} ${apellido2}`,
    };

    this.serviceGetAfiliado
      .getAfiliadoCore('buscar', acronym, document)
      .subscribe({
        next: (afiliadoResponse: GeneralResponse<any[]>) => {
          console.log('afiliadoResponse', afiliadoResponse);
          const detalleAfiliado = afiliadoResponse?.data?.[0];
          const numCartilla = detalleAfiliado?.numCartilla;
          const email_afiliado = detalleAfiliado?.email;
          const celular_afiliado = detalleAfiliado?.telefono_c;
          const tel_movil = detalleAfiliado.telefono_f;

          if (!numCartilla) {
            this.spinner.hide();
            return;
          } else {
          }

          mappedData = {
            ...mappedData,
            numCartilla,
          };

          if (email_afiliado) {
            mappedData = {
              ...mappedData,
              correo: email_afiliado,
            };
          }

          this.serviceGetAfiliado
            .getCartillaDetalle('consultarCiudades', numCartilla)
            .subscribe({
              next: (cartillaResponse) => {
                console.log('CartillaResponse', cartillaResponse);
                const detalleCartilla = cartillaResponse?.data?.[0];

                if (!detalleCartilla) {
                  this.spinner.hide();
                  return;
                }

                const payload = {
                  nombreClave: 'getciucorserv',
                  jsonParametros: JSON.stringify({ prm_codcarti: numCartilla }),
                };

                this.genericService
                  .post('consultarCiudades', payload)
                  .subscribe({
                    next: (ciudadResponse) => {
                      console.log('ciudadResponse', ciudadResponse);
                      const ciudades = ciudadResponse?.data || [];

                      if (!ciudades) {
                        this.spinner.hide();
                        return;
                      }

                      mappedData = {
                        ...mappedData,
                        ciudadesDisponibles: ciudades,
                      };

                      this.serviceGetAfiliado
                        .getCredencial(
                          'consultarCampoCredencial',
                          acronym,
                          document,
                        )
                        .subscribe({
                          next: (res) => {
                            console.log(
                              'Respuesta completa getCredencial:',
                              res,
                            );

                            // buscar credencial según el programa
                            const credencialObj = res?.data?.find(
                              (c: any) =>
                                c.nomPrograma === dataBeneficiario.programa,
                            );

                            if (credencialObj) {
                              console.log(
                                `✅ Credencial encontrada para programa ${dataBeneficiario.programa}:`,
                                credencialObj.CREDENCIAL,
                              );

                              mappedData = {
                                ...mappedData,
                                credencial: credencialObj.CREDENCIAL,
                              };
                            } else {
                              console.log(
                                `⚠️ No se encontró credencial para el programa: ${dataBeneficiario.programa}`,
                              );
                            }

                            // this.poblacionService
                            //   .getDetalleUsuarioMiPoblacion(datosConsulta)
                            //   .subscribe({
                            //     next: (response) => {
                            //       this.spinner.hide();

                            //       const detalle = response.data?.[0];
                            //       if (detalle?.Email) {
                            //         mappedData = {
                            //           ...mappedData,
                            //           correo: detalle.Email,
                            //         };
                            //       }
                            this.spinner.hide();
                            this.matDialog.open(FormularioSolicitudComponent, {
                              data: mappedData,
                            });
                          },
                          error: (error) => {
                            this.spinner.hide();
                          },
                        });
                    },
                    error: (error) => {
                      this.spinner.hide();
                    },
                  });
              },
              error: (error) => {
                this.spinner.hide();
              },
            });
        },
        error: (error) => {
          this.spinner.hide();
        },
      });
  }

  generateBill(data: Contrato) {
    if (data.showButtons) {
      const regex: RegExp = /([A-Z]{1,3})\s*[-]?\s*(\d+)/;
      const resultado: RegExpMatchArray | null = data.nombre.match(regex);
      if (resultado) {
        const docType = resultado[1];
        const docNumber = resultado[2];
        const url = `${ENV.HOST}${URL_MAP.EXTERNAL.FACTURA}?typeDocument=${docType}&documentNumber=${docNumber}`;
        console.log('Debug => Trying to open => ', url);
        this.matDialog.open(DialogGenericFrame, {
          width: '90%',
          data: { url: url },
        });
      } else {
        this.showMessageDialog(
          'Advertencia',
          'Ocurrió un error obteniendo la información del usuario.',
          'Aceptar',
          '',
          true,
          2,
          this.matDialog,
          (_: any) => {},
        );
      }
    } else {
      this.showMessageDialog(
        'Advertencia',
        'Lo sentimos, esta opción solo aplica para planes individuales.',
        'Aceptar',
        '',
        true,
        2,
        this.matDialog,
        (_: any) => {},
      );
    }
  }

  linkPago(data: Contrato) {
    const tipoRol = this.logInfo.roles[0].nombreRol;
    console.log('tipoRol => ', tipoRol);

    if (data.showButtons) {
      const regex: RegExp = /([A-Z]{1,3})\s*[-]?\s*(\d+)/;
      const resultado: RegExpMatchArray | null = data.nombre.match(regex);
      if (resultado) {
        const docType = resultado[1];
        const docNumber = resultado[2];
        const url = `${ENV.HOST}${
          URL_MAP.EXTERNAL.LINKPAGO
        }?&strNumeroDocumento=${docNumber}&strTipoDocumento=${docType}&strUsuario=${btoa(
          URL_MAP.EXTERNAL.autologinUserLinkPago,
        )}&strContrasenia=${btoa(URL_MAP.EXTERNAL.autologinPassLinkPago)}&strRol=${tipoRol}&desdeModal=true`;
        // const url = `http://localhost/link-de-pagos-coomeva/cuotamensual/obtener-datos?strNumeroDocumento=${docNumber}&strTipoDocumento=${docType}&strUsuario=${btoa(
        //   ENV.EXTERNAL.autologinUserLinkPago
        // )}&strContrasenia=${btoa(ENV.EXTERNAL.autologinPassLinkPago)}&strRol=${tipoRol}&desdeModal=true`;
        console.log('Debug => Trying to open => ', url);
        this.matDialog.open(DialogGenericFrame, {
          width: '90%',
          data: { url: url },
        });
      } else {
        this.showMessageDialog(
          'Advertencia',
          'Ocurrió un error obteniendo la información del usuario.',
          'Aceptar',
          '',
          true,
          2,
          this.matDialog,
          (_: any) => {},
        );
      }
    } else {
      this.showMessageDialog(
        'Advertencia',
        'Lo sentimos, esta opción solo aplica para planes individuales.',
        'Aceptar',
        '',
        true,
        2,
        this.matDialog,
        (_: any) => {},
      );
    }
  }

  get getControl(): { [key: string]: AbstractControl } {
    return this.frmPoblacion.controls;
  }

  disableArrowKeys(event: KeyboardEvent) {
    if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
      event.preventDefault();
    }
  }

  openCertificadosModal() {
    // Tomamos los datos del primer resultado de la búsqueda (dsPoblacion[0])
    // o según lo que necesites enviar al modal.
    const datosUsuario = this.dsPoblacion[0];

    const dialogRef = this.matDialog.open(ModalCertificadosComponent, {
      width: '650px',
      data: { usuario: this.usuariosMiPoblacion },
      panelClass: 'custom-dialog-container',
    });
  }

  deleteSpaceAsesor(identification: string): string {
    const parts = identification.split('.');
    return parts.length > 1 ? parts[1].trim() : '';
  }
}

export function noSpacesValidator(
  control: AbstractControl,
): ValidationErrors | null {
  const hasSpaces = (control.value || '').includes(' ');
  return hasSpaces ? { noSpaces: true } : null;
}

/**
 * Convierte una cadena en texto a Base64.
 * @param base64 La cadena en formato Base64.
 * @returns La cadena de texto codificada.
 */
function base64EncodeToString(text: string): string {
  try {
    return btoa(text);
  } catch (e) {
    return '';
  }
}
